import AppHeader from '../app/appHeader';
import React, { useEffect, useState } from 'react';
import './styles/paymentInProcess.scss';
import { Typography } from '@getgo/chameleon-web/react';
import Footer from '../footer/footer';
import { useTranslation } from 'react-i18next';
import { useEventContext } from '../context/eventContext';
import { useParams } from 'react-router';
import { IEventUrlParameters } from '../event/eventInterface';
import API from '../utils/api';
import FullScreenLoader from '../utils/fullScreenLoader/FullScreenLoader';
import { apiStatus } from '../../utils/constants';

const PaymentInProcess = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setLoading] = useState<boolean>(true);
  const { eventId } = useParams<IEventUrlParameters>();
  const { setEventDetails, eventDetails } = useEventContext();

  useEffect(() => {
    if (!eventDetails) {
      const getEvent = async () => {
        try {
          const eventData = await API.getEventDetails(eventId || '');
          const lang = eventData?.data?.locale?.split('_')[0]?.toLowerCase() || 'en';
          if (lang !== i18n.language) {
            i18n.changeLanguage(lang, () => {
              // TO-DO Change language for date
              document.documentElement.lang = lang === 'zh' ? 'zh-cn' : lang;
            });
          }
          if (eventData.status === apiStatus.success) {
            setEventDetails(eventData.data);
          }
        } catch (error) {
          console.log('error', error);
        }
      };
      getEvent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventDetails]);

  useEffect(() => {
    if (eventDetails?.locale.includes(i18n.language)) {
      setLoading(false);
    }
  }, [eventDetails?.locale, i18n.language]);
  return isLoading ? (
    <FullScreenLoader />
  ) : (
    <div className="payment-process-grid">
      <AppHeader />
      <div className="payment-process">
        <div className="box">
          <div className="box-space">
            <div>
              <Typography color="text-01" variant="heading-large">
                {t('paymentInProcess.title')}
              </Typography>
            </div>
            <div className="payment-process-description">
              <Typography color="text-01" variant="body-large">
                {t('paymentInProcess.dontRefresh')}
              </Typography>
            </div>
            <div>
              <Typography color="text-01" variant="body-large">
                {t('paymentInProcess.description')}
              </Typography>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentInProcess;
